var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChipLeft1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 136,
    viewBox: "0 0 266 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: -8,
    y: -8,
    width: 284,
    height: 152
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(5px)",
      clipPath: "url(#bgblur_0_2052_8413_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.593 115.322C261.363 113.293 266 107.063 266 99.9956L266 18C266 9.16344 258.837 2 250 2L18 2C9.16345 2 2 9.16344 2 18L2 118C2 126.837 9.16342 134 18 134L189.921 134C191.477 134 193.024 133.773 194.514 133.327L254.593 115.322Z",
    fill: "white",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.921 133.5L18 133.5C9.43958 133.5 2.5 126.56 2.5 118L2.5 18C2.5 9.43958 9.43959 2.5 18 2.5L250 2.5C258.56 2.5 265.5 9.43959 265.5 18L265.5 99.9961C265.5 106.628 261.284 112.5 255.059 114.647L254.449 114.843L194.37 132.848C192.927 133.28 191.428 133.5 189.921 133.5Z",
    stroke: "url(#paint0_linear_2052_8413)",
    strokeOpacity: 0.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 2H18C9.16344 2 2 9.16344 2 18V118C2 126.837 9.16344 134 18 134H97",
    stroke: "url(#paint1_linear_2052_8413)",
    strokeOpacity: 0.7,
    strokeWidth: 4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_2052_8413_clip_path",
    transform: "translate(8 8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.593 115.322C261.363 113.293 266 107.063 266 99.9956L266 18C266 9.16344 258.837 2 250 2L18 2C9.16345 2 2 9.16344 2 18L2 118C2 126.837 9.16342 134 18 134L189.921 134C191.477 134 193.024 133.773 194.514 133.327L254.593 115.322Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2052_8413",
    x1: 236.96,
    y1: 121.575,
    x2: 192.079,
    y2: -48.2373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2052_8413",
    x1: 97,
    y1: 68,
    x2: 2,
    y2: 68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.081934,
    stopColor: "#15BFFD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706057,
    stopColor: "#15BFFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChipLeft1);
export default __webpack_public_path__ + "static/media/chipLeft1.d004459c64cf9a9106228dada841ff67.svg";
export { ForwardRef as ReactComponent };